
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wallet/[coin]",
      function () {
        return require("private-next-pages/wallet/[coin]/index.p.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wallet/[coin]"])
      });
    }
  